import { format } from 'date-fns';
import React, { useState } from 'react';
import '../park/styles/datePicker.css';

type DateTimePickerProps = {
  date: Date;
  minDate?: Date;
  maxDate?: Date;
  onConfirm: (date: Date) => void;
};

const DateTimePicker: React.FC<DateTimePickerProps> = ({
  date,
  minDate,
  maxDate,
  onConfirm,
}) => {
  const [selectedDateTime, setSelectedDateTime] = useState(
    format(date, "yyyy-MM-dd'T'HH:mm")
  );

  // Ensure correct formatting for min/max dates
  const formattedMinDate = minDate
    ? format(minDate, "yyyy-MM-dd'T'HH:mm")
    : undefined;
  const formattedMaxDate = maxDate
    ? format(maxDate, "yyyy-MM-dd'T'HH:mm")
    : undefined;

  const handleDateTimeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newDateTime = event.target.value;
    if (!newDateTime) return;

    const selectedDate = new Date(newDateTime);
    // Validate manually if the input allows invalid values
    if (minDate && selectedDate < minDate) {
      console.warn('Selected date is below minDate, resetting to minDate');
      setSelectedDateTime(format(minDate, "yyyy-MM-dd'T'HH:mm"));
      onConfirm(minDate);
      return;
    }

    if (maxDate && selectedDate > maxDate) {
      console.warn('Selected date exceeds maxDate, resetting to maxDate');
      setSelectedDateTime(format(maxDate, "yyyy-MM-dd'T'HH:mm"));
      onConfirm(maxDate);
      return;
    }
    setSelectedDateTime(newDateTime);
    onConfirm(selectedDate);
  };

  return (
    <div className="datepicker-container">
      <input
        type="datetime-local"
        id="datetime"
        value={selectedDateTime}
        onChange={handleDateTimeChange}
        className="datepicker-input"
        min={formattedMinDate}
        max={formattedMaxDate}
      />
    </div>
  );
};

export default DateTimePicker;
